export default {"src":"/_next/static/media/Male-04.d73cd3a3.svg","height":96,"width":96,"blurWidth":0,"blurHeight":0};